import { HttpContextToken, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { LoaderService } from '../services/loader.service';

export const LOADER_MESSAGE = new HttpContextToken<string | null>(() => null);
export const SKIP_LOADER = new HttpContextToken<boolean>(() => false);

const SPECIAL_MESSAGES: Record<string, string> = {
  userlogin: 'Signing in',
  'get-refresh-token': 'Refreshing session',
  'getsubmissionsforunderwriterpaginated': 'Loading submissions',
  'submissions/list-by-filter': 'Loading filtered submissions',
  'get-all-submissions': 'Loading submissions',
  'check_submission_status': 'Checking submission status',
  'risk-profile/v2': 'Loading submission insights',
  'risk-profile/': 'Loading submission insights',
  'process-submission': 'Processing submission',
};

export const loaderInterceptor: HttpInterceptorFn = (request, next) => {
  if (request.context.get(SKIP_LOADER)) {
    return next(request);
  }

  const loader = inject(LoaderService);
  const loaderId = loader.begin(resolveLoaderMessage(request.url, request.method, request.context.get(LOADER_MESSAGE)));

  return next(request).pipe(
    finalize(() => {
      loader.end(loaderId);
    })
  );
};

function resolveLoaderMessage(url: string, method: string, override: string | null): string {
  const explicit = override?.trim();
  if (explicit) {
    return explicit;
  }

  const lowerUrl = url.toLowerCase();
  const specialKey = Object.keys(SPECIAL_MESSAGES).find((key) => lowerUrl.includes(key));

  if (specialKey) {
    return SPECIAL_MESSAGES[specialKey];
  }

  if (method === 'POST' || method === 'PUT' || method === 'PATCH') {
    return 'Saving changes';
  }

  if (method === 'DELETE') {
    return 'Removing record';
  }

  const label = formatUrlLabel(url);
  return label ? `Loading ${label}` : 'Loading';
}

function formatUrlLabel(url: string): string {
  const cleaned = url
    .split('?')[0]
    .replace(/^https?:\/\/[^/]+/i, '')
    .split('/')
    .filter(Boolean)
    .pop();

  if (!cleaned) {
    return '';
  }

  return cleaned
    .replace(/^(get|fetch|load|list|read)-/i, '')
    .replace(/[-_]+/g, ' ')
    .trim();
}
